/**
 *
 *
 */

import RiskFactor from './risk-factor';

export default class CVVMessage extends RiskFactor {
    icon = 'credit-card';

    label = '<span class="has-tooltip has-tooltip-help" data-tooltip="Card Verification Value">CVV</span> Message';

    static getCondition({cvvResponse}) {
        return !!cvvResponse && cvvResponse.message !== null;
    }

    parse({cvvResponse}) {
        this.cvvResponse = cvvResponse;
    }

    getResult() {
        return this.cvvResponse.message;
    }
}
